export default {
    data() {
        return {
            valid: false,
            person: {
                nationality: '0',
                document: '',
                name: '',
                birthDate: '',
                email: '',
                institution: '',
                notify: true
            },
            nationalities: [
                { id: '0', name: 'Brasileiro' },
                { id: '2', name: 'Estrangeiro' },
            ],
            rules: {
                name: [
                    (v) => !!v || 'O nome precisa ser informado'
                ],
                document: [
                    (v) => !!v || 'O ' + this.documentLabel + ' precisa ser informado',
                    (v) => this.person.nationality == '0' && v.length == 11 || 'Informe os 11 dígitos do CPF'
                ],
                date: [
                    (v) => !!v || 'A data de nascimento precisa ser informada',
                    (v) => v.length == 8 || 'A data de nascimento informada é inválida'
                ],
                email: [
                    (v) => !!v || 'O e-mail precisa ser informado',
                    (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'O e-mail informado é inválido'                        
                ],
                institution: [
                    (v) => !!v || 'A instituição deve ser informada. SIGLA - NOME',
                    // (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'O e-mail informado é inválido'                        
                ],
            },
            error: '',
            exists: {
                typeDescription: '',
                id: '',
                examinerStatus: '',
                email: '',
                institution: '',
                name: ''
            },
            canSendAccess: false,
            accessSent: false,            
            showActions: false        
        }
    },
    computed: {
        documentLabel: function() {
            if (this.person.nationality == '2') {
                return 'Passaporte'
            }
            return 'CPF'
        },
        documentMask: function() {
            if (this.person.nationality == '2') {
                return null //Passaport
            }
            return '###.###.###-##' //CPF
        }
    },
    methods: {
        handleErrors(errors) {
            if (typeof errors !== 'undefined') {
                this.error = errors.join()
            } else {
                this.error = 'Não foi possível realizar a operação.'
            }
        }
    },
    created: function () {
        this.showActions = typeof this.$slots['actions'] !== 'undefined'
    }        

}


// WEBPACK FOOTER //
// ./src/components/RegisterExternalMixin.js